import script from "./MTFTargets.vue?vue&type=script&lang=js"
export * from "./MTFTargets.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__